import { COMMON_WAIFUS, getCommonReviews } from '../../../constants.js';

export const PT_BASE = {
    hero: {
      title: "Waifu Briscola",
      tagline: "A Briscola como você nunca viu: RPG, Waifu e IA.",
      ctaWeb: "Jogar na Web",
      ctaAndroid: "Baixar para Android",
      version: "Versão 2.3",
      badge: "✨ Novo Modo Masmorra"
    },
    stats: {
      downloads: "Downloads",
      downloadsValue: ["Não dá pra contar!", "Servidores Cheios", "Um monte!", "Mais de 9000", "Muitos para contar"],
      hands: "Mãos Perdidas",
      handsValue: ["Muitas...", "Falta de Habilidade", "Culpa do Lag", "Ainda chorando", "Tente de novo, terá mais sorte"],
      rating: "Avaliação",
      ratingValue: ["Minha avó aprova", "11/10 - IGN", "Melhor que pizza", "GOTY 2026", "Obra-prima Absoluta"],
      waifus: "Waifu",
      waifusValue: ["Todas para você", "Só 2D > 3D", "Colecione todas!", "Waifu > Meta", "O verdadeiro tesouro"]
    },
    features: {
      title: "Muito mais que um jogo de cartas",
      items: [
        { id: "classic", title: "Briscola Clássica", description: "A experiência original, perfeita e limpa.", icon: "🃏" },
        { id: "roguelike", title: "RPG Roguelike", description: "Escale a torre, obtenha poderes elementais e derrote os chefes.", icon: "⚔️" },
        { id: "ai", title: "IA Viva", description: "Graças ao Google Gemini, as oponentes te insultam ou te elogiam em tempo real.", icon: "🧠" },
        { id: "gacha", title: "Sistema Gacha", description: "Use moedas para desbloquear novas skins e fundos raros.", icon: "💎" },
        { id: "dungeon", title: "Modo Masmorra", description: "Enfrente chefes com regras malucas. Uma derrota e acabou.", icon: "🏰" },
        { id: "puzzle", title: "Modo Puzzle", description: "Resolva cenários complexos com objetivos específicos.", icon: "🧩" }
      ]
    },
    video: { title: "Trailer de Gameplay" },
    waifus: {
      title: "Escolha sua Parceira",
      subtitle: "Cada personagem tem uma personalidade única, dublagem e estilo de jogo.",
      characters: [
        { ...COMMON_WAIFUS[0], name: "Miu", role: "A Doce", personality: "Doce e solar, adora ficar perto de você." },
        { ...COMMON_WAIFUS[1], name: "Rei", role: "A Analítica", personality: "Calculista e fria. Apenas lógica." },
        { ...COMMON_WAIFUS[2], name: "Akame", role: "A Tsundere", personality: "Competitiva e fogosa. Odeia perder." },
        { ...COMMON_WAIFUS[3], name: "Lilith", role: "A Rainha", personality: "A rainha sombria das cartas." },
        { ...COMMON_WAIFUS[4], name: "Mochi", role: "A Guia", personality: "Sua guia confiável... talvez." }
      ]
    },
    reviews: {
      title: "Dizem sobre nós (infelizmente)",
      items: getCommonReviews('pt')
    },
    ctaStrip: {
      title: "Pronto para entrar em campo?",
      subtitle: "Junte-se a outros jogadores e comece sua aventura hoje.",
      button: "Começar a Jogar Agora"
    },
    footer: { privacy: "Privacidade", terms: "Termos", copyright: "© 2026 Waifu Briscola" },
    privacy: {
      title: "Política de Privacidade da Waifu Briscola",
      lastUpdated: "Última atualização: 25 de Maio de 2024",
      intro: "Esta Política de Privacidade descreve como suas informações são gerenciadas quando você usa o aplicativo Waifu Briscola ('Serviço').",
      sections: [
        {
          title: "Informações que coletamos",
          intro: "Para melhorar sua experiência, usamos serviços de terceiros que podem coletar informações:",
          items: [
            "Dados de uso (PostHog): Coletamos dados analíticos anônimos ou pseudônimos sobre como você interage com o jogo. Isso inclui eventos como o início de uma partida, cartas jogadas e resultados finais. Esses dados nos ajudam a entender como o jogo é usado e como podemos melhorá-lo. Não coletamos informações de identificação pessoal (PII) através do PostHog.",
            "Interações com a IA (Google Gemini): As mensagens de chat que você envia e as informações sobre o estado do jogo (como as cartas na sua mão e na mesa) são enviadas para a API do Google Gemini para gerar as respostas e movimentos da IA. Essas interações estão sujeitas à Política de Privacidade do Google. Não enviamos nenhuma informação pessoal ao Google além do conteúdo de suas interações no jogo.",
          ],
        },
        {
          title: "Como usamos suas informações",
          intro: "Usamos as informações coletadas para:",
          items: [
            "Fornecer, operar e manter nosso Serviço.",
            "Melhorar, personalizar e expandir nosso Serviço.",
            "Entender e analisar como você usa nosso Serviço.",
            "Prevenir abusos e garantir a segurança.",
          ],
        },
        {
          title: "Compartilhamento de informações",
          body: "Não compartilhamos suas informações pessoais com ninguém, exceto com os provedores de serviços terceirizados (PostHog, Google) necessários para o funcionamento do aplicativo, conforme descrito acima.",
        },
        {
          title: "Segurança dos dados",
          body: "A segurança de suas informações é importante para nós, mas lembre-se de que nenhum método de transmissão pela Internet ou método de armazenamento eletrônico é 100% seguro.",
        },
        {
          title: "Alterações nesta Política de Privacidade",
          body: "Podemos atualizar nossa Política de Privacidade de tempos em tempos. Informaremos sobre quaisquer alterações publicando a nova Política de Privacidade nesta página.",
        },
        {
          title: "Contate-nos",
          body: "Se você tiver dúvidas sobre esta Política de Privacidade, pode contatar o responsável Mauro Mazzocchetti.",
        },
      ],
    },
    consent: { text: "Usamos cookies e análises para melhorar o site. Ao continuar, você aceita nossa", ok: "Entendi" },
    terms: {
      title: "Termos e Condições da Waifu Briscola",
      lastUpdated: "Última atualização: 25 de Maio de 2024",
      contact: "Responsável: Mauro Mazzocchetti",
      intro: "Bem-vindo ao Waifu Briscola! Estes termos e condições descrevem as regras para o uso do aplicativo Waifu Briscola ('Serviço').",
      sections: [
        {
          title: "Aceitação dos Termos",
          body: "Ao acessar e usar este Serviço, você concorda em ficar vinculado a estes Termos. Se você não concordar com qualquer parte dos termos, não poderá usar o Serviço.",
        },
        {
          title: "Uso do Serviço",
          body: "Você concorda em não usar o Serviço para fins ilegais ou não autorizados. Você é responsável por sua conduta e por qualquer conteúdo que fornecer durante o uso do Serviço, incluindo mensagens de chat.",
        },
        {
          title: "Conteúdo Gerado por IA",
          intro: "O Serviço usa modelos de inteligência artificial (Google Gemini) para gerar respostas, comentários e movimentos de jogo. Você reconhece que:",
          items: [
            "O conteúdo gerado por IA é produzido por um modelo e pode nem sempre ser preciso, apropriado ou consistente.",
            "Não somos responsáveis pelo conteúdo gerado por IA.",
            "As interações com a IA destinam-se apenas a fins de entretenimento.",
          ],
        },
        {
          title: "Limitação de Responsabilidade",
          body: "Em nenhum caso Mauro Mazzocchetti, nem seus parceiros, serão responsáveis por quaisquer danos indiretos, incidentais, especiais, consequenciais ou punitivos, incluindo, sem limitação, perda de lucros, dados, fundo de comércio ou outras perdas intangíveis, resultantes de (i) seu acesso ou uso ou incapacidade de acessar ou usar o Serviço; (ii) qualquer conteúdo obtido do Serviço.",
        },
        {
          title: "Alterações nos Termos",
          body: "Reservamo-nos o direito, a nosso exclusivo critério, de modificar ou substituir estes Termos a qualquer momento. Informaremos sobre quaisquer alterações publicando os novos termos nesta página.",
        },
        {
          title: "Lei Aplicável",
          body: "Estes Termos serão regidos e interpretados de acordo com as leis italianas, sem levar em consideração suas disposições sobre conflitos de leis.",
        },
      ],
    }
};
